<div style="display: flex; flex-direction: column; margin-right: 10px">
  <div
    *ngIf="isLoading"
    [style.height.px]="size"
    [style.width.px]="size"
    style="
      display: flex;
      background: var(--ion-color-step-50);
      align-items: center;
      justify-content: center;
      border-radius: 6px;
    "
  >
    <ion-spinner name="crescent" color="primary"></ion-spinner>
  </div>
  <ng-container>
    <a
      *ngIf="!isLoading"
      color="light"
      class="btn-large"
      (click)="url ? expandPreviewImageForId(id) : downloadFile(id)"
      [title]="name"
      style="height: fit-content; width: fit-content"
    >
      <img
        *ngIf="url"
        [src]="url"
        class="depthButton"
        [style.max-height.px]="size"
        style="max-width: 100%; border-radius: 6px; box-shadow: 0px 0px 0px 2px var(--card-shadow-color)"
      />
      <ion-button color="light" *ngIf="!url" class="btn-large">
        <ion-icon name="cloud-download-outline" class="icon-padded"></ion-icon>
        {{ shortname ?? 'Download' }}
      </ion-button>
    </a>
    <div *ngIf="!isLoading && url">
      <ion-icon
        *ngIf="!error && id"
        name="cloud-download-outline"
        class="icon-padded"
        style="cursor: pointer"
        (click)="downloadFile(id)"
      ></ion-icon>
      <ion-label style="font-size: 12px">{{ shortname }}</ion-label>
    </div>
    <!-- For some reason, 6px is appended to the loaded image, so we try to match that -->
    <!-- Matching the height makes the scrollToBottom actually reach the bottom of page -->
    <div *ngIf="!url && isLoading" style="margin-top: 6px">
      <ion-icon name="ellipsis-horizontal" class="icon-padded"></ion-icon>
      <ion-label *ngIf="!url && isLoading" style="font-size: 12px">Loading...</ion-label>
    </div>
  </ng-container>
</div>

<ion-modal [isOpen]="previewExpanded" (willDismiss)="onDismissPreview()" class="image-preview-modal">
  <ng-template>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-button (click)="onDismissPreview()">
            <ion-icon name="close-outline"></ion-icon>
          </ion-button>
        </ion-buttons>
        <ion-title>
          <b>{{ previewName }}</b>
        </ion-title>
        <ion-buttons slot="end">
          <ion-button (click)="downloadFile(previewId)">
            <ion-icon name="cloud-download-outline"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <div
        style="display: flex; justify-content: center; align-items: center; height: 100%"
        (click)="onDismissPreview()"
      >
        <img *ngIf="!previewLoading" [src]="previewUrl" style="max-width: 100%; max-height: 100%" />
        <ion-spinner name="crescent" *ngIf="previewLoading"></ion-spinner>
      </div>
    </ion-content>
  </ng-template>
</ion-modal>
